export default __webpack_public_path__ + "static/media/services-header.8faa46b9.png";